module.exports = __webpack_public_path__ + "static/img/process-green.4954f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/process-green.png
// module id = UbeK
// module chunks = 1